import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import api, { uploadsBaseUrl } from '../../../api';
import DashboardLayout from '../../../Components/Dashboard/DashboardLayout';
import './AdminSuite.css';

const formatDate = value => {
  if (!value) return 'TBA';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value).slice(0, 10);
  return date.toLocaleDateString();
};

const AdminEnrollmentsPage = () => {
  const [enrollments, setEnrollments] = useState([]);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await api.get('/admin/enrollments');
    setEnrollments(res.data?.data || []);
  };

  const review = async (id, decision, notes) => {
    await api.patch(`/admin/enrollments/${id}/review`, {
      status: decision,
      review_notes: notes,
    });
    toast.success('Reviewed');
    load();
  };

  return (
    <DashboardLayout>
      <div className="container py-4 admin-suite">
        <div className="admin-suite-header">
          <div>
            <h3 className="admin-suite-title">Enrollment Management</h3>
            <p className="admin-suite-subtitle">Review payment proofs and approve student intakes.</p>
          </div>
          <span className="badge bg-light text-dark">Total: {enrollments.length}</span>
        </div>

        <div className="list-group mt-3 shadow-sm rounded-3 overflow-hidden admin-card">
          {enrollments.map(enrollment => (
            <div key={enrollment.id} className="list-group-item p-3">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="mb-1">
                    <strong>{enrollment.user?.name || enrollment.user?.fullName}</strong> -{' '}
                    {enrollment.course?.title}
                  </div>
                  <div className="small text-muted">Status: {enrollment.status}</div>
                  <div className="small text-muted">
                    Intake: {enrollment.intakeSession?.name || enrollment.intake || '-'}
                    {enrollment.intakeSession
                      ? ` (${formatDate(enrollment.intakeSession.start_date)} - ${formatDate(enrollment.intakeSession.end_date)})`
                      : ''}
                  </div>
                  <div className="small text-muted">Phone: {enrollment.phone_number}</div>
                  <div className="small text-muted">Notes: {enrollment.additional_notes || '-'}</div>
                  {enrollment.payment_proof && (
                    <a
                      className="btn btn-sm btn-outline-secondary mt-2"
                      href={`${uploadsBaseUrl}/storage/${enrollment.payment_proof}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      View payment proof
                    </a>
                  )}
                </div>

                {enrollment.status === 'pending_payment_verification' && (
                  <div className="d-flex gap-2">
                    <button className="btn btn-sm btn-success" onClick={() => review(enrollment.id, 'approved', 'Approved')}>
                      Approve
                    </button>
                    <button className="btn btn-sm btn-danger" onClick={() => review(enrollment.id, 'rejected', 'Rejected')}>
                      Reject
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="d-none">
          <Link to={uploadsBaseUrl}>hidden</Link>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AdminEnrollmentsPage;
